var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      attrs: { "data-vv-scope": "custom-document", autocomplete: "off" },
      on: {
        submit: function($event) {
          $event.preventDefault()
        }
      }
    },
    [
      _c("h2", { staticClass: "mb-10" }, [
        _vm._v("Formulario de Solicitud Compra de Pasajes")
      ]),
      _vm._m(0),
      _c("div", { staticClass: "row mt-2" }, [
        _vm._m(1),
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c(
              "b-form-group",
              { attrs: { label: "Nombre *" } },
              [
                _c("b-form-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  attrs: {
                    state: _vm.errors.has("custom-document.name")
                      ? false
                      : null,
                    "data-vv-as": "nombre",
                    "data-cy": "name",
                    name: "name",
                    maxLength: "150"
                  },
                  model: {
                    value: _vm.formData.name,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "name", $$v)
                    },
                    expression: "formData.name"
                  }
                }),
                _vm.errors.has("custom-document.name")
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "con-text-validation span-text-validation-danger v-enter-to"
                      },
                      [
                        _c("span", { staticClass: "span-text-validation" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.errors.first("custom-document.name")) +
                              " "
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c(
              "b-form-group",
              { attrs: { label: "Apellidos *" } },
              [
                _c("b-form-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  attrs: {
                    state: _vm.errors.has("custom-document.surnames")
                      ? false
                      : null,
                    "data-vv-as": "apellidos",
                    "data-cy": "surnames",
                    name: "surnames",
                    maxLength: "150"
                  },
                  model: {
                    value: _vm.formData.surnames,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "surnames", $$v)
                    },
                    expression: "formData.surnames"
                  }
                }),
                _vm.errors.has("custom-document.surnames")
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "con-text-validation span-text-validation-danger v-enter-to"
                      },
                      [
                        _c("span", { staticClass: "span-text-validation" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.errors.first("custom-document.surnames")
                              ) +
                              " "
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-4" },
          [
            _c(
              "b-form-group",
              { attrs: { label: "Cédula de identidad *" } },
              [
                _c("b-form-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|validateRut",
                      expression: "'required|validateRut'"
                    }
                  ],
                  attrs: {
                    state: _vm.errors.has("custom-document.iut") ? false : null,
                    "data-vv-as": "rut",
                    "data-cy": "iut",
                    name: "iut",
                    placeholder: "12345678-9"
                  },
                  on: {
                    blur: function($event) {
                      return _vm.formatIut(_vm.formData.iut, undefined, "si")
                    }
                  },
                  model: {
                    value: _vm.formData.iut,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "iut", $$v)
                    },
                    expression: "formData.iut"
                  }
                }),
                _vm.errors.has("custom-document.iut")
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "con-text-validation span-text-validation-danger v-enter-to"
                      },
                      [
                        _c("span", { staticClass: "span-text-validation" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.errors.first("custom-document.iut")) +
                              " "
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-4" },
          [
            _c(
              "b-form-group",
              { attrs: { label: "Fecha de nacimiento *" } },
              [
                _c("date-picker", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  staticClass: "w-100",
                  attrs: {
                    "data-cy": "birthdate",
                    name: "birthdate",
                    format: "DD-MM-YYYY",
                    "value-type": "YYYY-MM-DD",
                    "data-vv-as": "fecha de nacimiento",
                    danger: _vm.errors.has("custom-document.birthdate"),
                    "danger-text": _vm.errors.first("custom-document.birthdate")
                  },
                  model: {
                    value: _vm.formData.birthdate,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "birthdate", $$v)
                    },
                    expression: "formData.birthdate"
                  }
                }),
                _vm.errors.has("custom-document.birthdate")
                  ? _c("div", [
                      _c("small", { staticClass: "text-danger" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.errors.first("custom-document.birthdate")
                            ) +
                            " "
                        )
                      ])
                    ])
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-4" },
          [
            _c(
              "b-form-group",
              { attrs: { label: "Teléfono *" } },
              [
                _c("b-form-input", {
                  directives: [
                    {
                      name: "mask",
                      rawName: "v-mask",
                      value: "+569 ####-####",
                      expression: "'+569 ####-####'"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: {
                        required: true
                      },
                      expression: "{\n            required: true\n          }"
                    }
                  ],
                  attrs: {
                    state: _vm.errors.has("custom-document.phone")
                      ? false
                      : null,
                    "data-vv-as": "teléfono",
                    "data-cy": "phone",
                    name: "phone",
                    placeholder: "+569 1234-5678"
                  },
                  model: {
                    value: _vm.formData.phone,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "phone", $$v)
                    },
                    expression: "formData.phone"
                  }
                }),
                _vm.errors.has("custom-document.phone")
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "con-text-validation span-text-validation-danger v-enter-to"
                      },
                      [
                        _c("span", { staticClass: "span-text-validation" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.errors.first("custom-document.phone")
                              ) +
                              " "
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row" }, [
        _vm._m(2),
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "label",
              {
                staticClass: "col-sm-2 col-form-label",
                attrs: { for: "tripType" }
              },
              [_vm._v("Tipo de viaje *")]
            ),
            _c(
              "div",
              { staticClass: "col-sm-10" },
              [
                _c("vs-radio", {
                  attrs: {
                    type: "radio",
                    id: "oneWay",
                    "vs-name": "tripType",
                    "vs-value": "oneWay"
                  },
                  model: {
                    value: _vm.formData.tripType,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "tripType", $$v)
                    },
                    expression: "formData.tripType"
                  }
                }),
                _c("label", { attrs: { for: "oneWay" } }, [_vm._v("Solo ida")]),
                _c("br"),
                _c("vs-radio", {
                  attrs: {
                    type: "radio",
                    id: "roundTrip",
                    "vs-name": "tripType",
                    "vs-value": "roundTrip"
                  },
                  model: {
                    value: _vm.formData.tripType,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "tripType", $$v)
                    },
                    expression: "formData.tripType"
                  }
                }),
                _c("label", { attrs: { for: "roundTrip" } }, [
                  _vm._v("Ida y vuelta")
                ])
              ],
              1
            )
          ])
        ]),
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c(
              "b-form-group",
              { attrs: { label: "Origen *" } },
              [
                _c("b-form-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  attrs: {
                    state: _vm.errors.has("custom-document.from")
                      ? false
                      : null,
                    "data-vv-as": "origen",
                    "data-cy": "from",
                    name: "from",
                    maxLength: "150"
                  },
                  model: {
                    value: _vm.formData.from,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "from", $$v)
                    },
                    expression: "formData.from"
                  }
                }),
                _vm.errors.has("custom-document.from")
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "con-text-validation span-text-validation-danger v-enter-to"
                      },
                      [
                        _c("span", { staticClass: "span-text-validation" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.errors.first("custom-document.from")) +
                              " "
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c(
              "b-form-group",
              { attrs: { label: "Destino *" } },
              [
                _c("b-form-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  attrs: {
                    state: _vm.errors.has("custom-document.to") ? false : null,
                    "data-vv-as": "destino",
                    "data-cy": "to",
                    name: "to",
                    maxLength: "150"
                  },
                  model: {
                    value: _vm.formData.to,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "to", $$v)
                    },
                    expression: "formData.to"
                  }
                }),
                _vm.errors.has("custom-document.to")
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "con-text-validation span-text-validation-danger v-enter-to"
                      },
                      [
                        _c("span", { staticClass: "span-text-validation" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.errors.first("custom-document.to")) +
                              " "
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-6" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Fecha ida *" } },
                  [
                    _c("date-picker", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      staticClass: "w-100",
                      attrs: {
                        "data-cy": "departure-date",
                        name: "departureDate",
                        format: "DD-MM-YYYY",
                        "value-type": "YYYY-MM-DD",
                        "data-vv-as": "fecha ida",
                        danger: _vm.errors.has("custom-document.departureDate"),
                        "danger-text": _vm.errors.first(
                          "custom-document.departureDate"
                        )
                      },
                      model: {
                        value: _vm.formData.departureDate,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "departureDate", $$v)
                        },
                        expression: "formData.departureDate"
                      }
                    }),
                    _vm.errors.has("custom-document.departureDate")
                      ? _c("div", [
                          _c("small", { staticClass: "text-danger" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.errors.first(
                                    "custom-document.departureDate"
                                  )
                                ) +
                                " "
                            )
                          ])
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-6" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Hora ida *" } },
                  [
                    _c(
                      "v-select",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "w-100",
                        class: {
                          "v-select-danger": _vm.errors.has(
                            "custom-document.departureTime"
                          )
                        },
                        attrs: {
                          "data-cy": "departure-time",
                          "data-vv-as": "hora ida",
                          name: "departureTime",
                          options: _vm.optionsTime
                        },
                        model: {
                          value: _vm.formData.departureTime,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "departureTime", $$v)
                          },
                          expression: "formData.departureTime"
                        }
                      },
                      [
                        _c("template", { slot: "no-options" }, [
                          _vm._v(
                            " no hay hora ida para el criterio de búsqueda "
                          )
                        ])
                      ],
                      2
                    ),
                    _vm.errors.has("custom-document.departureTime")
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "con-text-validation span-text-validation-danger v-enter-to"
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "span-text-validation" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.errors.first(
                                        "custom-document.departureTime"
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]),
        _vm.formData.tripType === "roundTrip"
          ? _c("div", { staticClass: "col-md-12" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-md-6" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Fecha regreso *" } },
                      [
                        _c("date-picker", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass: "w-100",
                          attrs: {
                            "data-cy": "return-date",
                            name: "returnDate",
                            format: "DD-MM-YYYY",
                            "value-type": "YYYY-MM-DD",
                            "data-vv-as": "fecha regreso",
                            danger: _vm.errors.has(
                              "custom-document.returnDate"
                            ),
                            "danger-text": _vm.errors.first(
                              "custom-document.returnDate"
                            )
                          },
                          model: {
                            value: _vm.formData.returnDate,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "returnDate", $$v)
                            },
                            expression: "formData.returnDate"
                          }
                        }),
                        _vm.errors.has("custom-document.returnDate")
                          ? _c("div", [
                              _c("small", { staticClass: "text-danger" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.errors.first(
                                        "custom-document.returnDate"
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-md-6" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Hora regreso *" } },
                      [
                        _c(
                          "v-select",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            staticClass: "w-100",
                            class: {
                              "v-select-danger": _vm.errors.has(
                                "custom-document.returnTime"
                              )
                            },
                            attrs: {
                              "data-cy": "return-time",
                              "data-vv-as": "hora regreso",
                              name: "returnTime",
                              options: _vm.optionsTime
                            },
                            model: {
                              value: _vm.formData.returnTime,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "returnTime", $$v)
                              },
                              expression: "formData.returnTime"
                            }
                          },
                          [
                            _c("template", { slot: "no-options" }, [
                              _vm._v(
                                " no hay hora ida para el criterio de búsqueda "
                              )
                            ])
                          ],
                          2
                        ),
                        _vm.errors.has("custom-document.returnTime")
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "con-text-validation span-text-validation-danger v-enter-to"
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "span-text-validation" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.errors.first(
                                            "custom-document.returnTime"
                                          )
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ])
          : _vm._e()
      ]),
      _c("div", { staticClass: "row" }, [
        _vm._m(3),
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _c(
              "b-form-group",
              { attrs: { label: "Motivo de viaje *" } },
              [
                _c("b-form-textarea", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  attrs: {
                    state: _vm.errors.has("custom-document.reason")
                      ? false
                      : null,
                    "data-cy": "reason",
                    "data-vv-as": "motivo de viaje",
                    name: "reason",
                    type: "text",
                    rows: "3",
                    maxLength: "5000"
                  },
                  model: {
                    value: _vm.formData.reason,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "reason", $$v)
                    },
                    expression: "formData.reason"
                  }
                }),
                _c("div", { staticClass: "text-right" }, [
                  _c(
                    "small",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Contador de caracteres",
                          expression: "'Contador de caracteres'"
                        }
                      ]
                    },
                    [_vm._v(_vm._s(_vm.formData.reason.length) + "/5000")]
                  )
                ]),
                _vm.errors.has("custom-document.reason")
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "con-text-validation span-text-validation-danger v-enter-to"
                      },
                      [
                        _c("span", { staticClass: "span-text-validation" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.errors.first("custom-document.reason")
                              ) +
                              " "
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "label",
              {
                staticClass: "col-sm-2 col-form-label",
                attrs: { for: "retinue" }
              },
              [_vm._v("Viaja en comitiva *")]
            ),
            _c(
              "div",
              { staticClass: "col-sm-10" },
              [
                _c("vs-radio", {
                  attrs: {
                    type: "radio",
                    id: "yes",
                    "vs-name": "retinue",
                    "vs-value": 1
                  },
                  model: {
                    value: _vm.formData.retinue,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "retinue", $$v)
                    },
                    expression: "formData.retinue"
                  }
                }),
                _c("label", { attrs: { for: "yes" } }, [_vm._v("Si")]),
                _c("br"),
                _c("vs-radio", {
                  attrs: {
                    type: "radio",
                    id: "no",
                    "vs-name": "retinue",
                    "vs-value": 0
                  },
                  model: {
                    value: _vm.formData.retinue,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "retinue", $$v)
                    },
                    expression: "formData.retinue"
                  }
                }),
                _c("label", { attrs: { for: "no" } }, [
                  _vm._v("No (invitación va dirigida directamente al pasajero)")
                ])
              ],
              1
            )
          ])
        ]),
        _c("div", { staticClass: "col-md-12" }, [
          _c(
            "div",
            { staticClass: "row align-items-center mt-5" },
            [
              _vm._m(4),
              _c(
                "div",
                { staticClass: "col-md-3 align-items-end" },
                [
                  _c("UploadFile", {
                    attrs: {
                      permission: "*",
                      accept: "application/pdf, .doc, .docx, .xlsx, .ppt",
                      text: "Seleccionar documentos",
                      "upload-to": "ed",
                      "button-class": {
                        "btn-block": true,
                        "mb-5": _vm.errors.has("custom-document.fileName")
                      },
                      "container-class": "w-100"
                    },
                    on: {
                      input: function($event) {
                        return _vm.addItineraryFile()
                      }
                    },
                    model: {
                      value: _vm.fileItinerary,
                      callback: function($$v) {
                        _vm.fileItinerary = $$v
                      },
                      expression: "fileItinerary"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-md-3 align-items-end" },
                [
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "has-permission",
                          rawName: "v-has-permission",
                          value: "ED060",
                          expression: "'ED060'"
                        },
                        {
                          name: "b-modal",
                          rawName: "v-b-modal",
                          value: "add-file-repository",
                          expression: "'add-file-repository'"
                        }
                      ],
                      staticClass: "btn-icon mt-1",
                      attrs: {
                        variant: "secondary",
                        "data-cy": "from-repository"
                      },
                      on: {
                        click: function($event) {
                          return _vm.selectItineraryFiles("itinerary")
                        }
                      }
                    },
                    [
                      _c("feather-icon", { attrs: { icon: "ServerIcon" } }),
                      _vm._v(" Desde el repositorio ")
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._l(_vm.formData.filesItinerary, function(file) {
                return _c("div", { key: file.id, staticClass: "col-3" }, [
                  _c(
                    "div",
                    { staticClass: "d-flex flex-column align-items-center" },
                    [
                      _c("vs-icon", {
                        attrs: {
                          icon: "description",
                          size: "45px",
                          color: "primary"
                        }
                      }),
                      _c(
                        "b",
                        { staticClass: "text-truncate w-100 text-center" },
                        [_vm._v(_vm._s(file.name))]
                      ),
                      _c("vs-button", {
                        attrs: { color: "danger", type: "flat", icon: "clear" },
                        on: {
                          click: function($event) {
                            return _vm.removeItineraryFile(file.id)
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              }),
              _c("div", { staticClass: "col-md-12" }, [
                !!_vm.error.messageItinerary
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "con-text-validation span-text-validation-danger\n            vs-input--text-validation-span v-enter-to text-left"
                      },
                      [
                        _c("span", { staticClass: "span-text-validation" }, [
                          _vm._v(" " + _vm._s(_vm.error.messageItinerary) + " ")
                        ])
                      ]
                    )
                  : _vm._e()
              ])
            ],
            2
          )
        ]),
        _c("div", { staticClass: "col-md-12" }, [
          _c(
            "div",
            { staticClass: "row align-items-center mt-5" },
            [
              _vm._m(5),
              _c(
                "div",
                { staticClass: "col-md-3 align-items-end" },
                [
                  _c("UploadFile", {
                    attrs: {
                      permission: "*",
                      accept: "application/pdf, .doc, .docx, .xlsx, .ppt",
                      text: "Seleccionar documentos",
                      "upload-to": "ed",
                      "button-class": {
                        "btn-block": true,
                        "mb-5": _vm.errors.has("custom-document.fileName")
                      },
                      "container-class": "w-100"
                    },
                    on: {
                      input: function($event) {
                        return _vm.addOthersFile()
                      }
                    },
                    model: {
                      value: _vm.fileOthers,
                      callback: function($$v) {
                        _vm.fileOthers = $$v
                      },
                      expression: "fileOthers"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-md-3 align-items-end" },
                [
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "has-permission",
                          rawName: "v-has-permission",
                          value: "ED060",
                          expression: "'ED060'"
                        },
                        {
                          name: "b-modal",
                          rawName: "v-b-modal",
                          value: "add-file-repository",
                          expression: "'add-file-repository'"
                        }
                      ],
                      staticClass: "btn-icon mt-1",
                      attrs: {
                        variant: "secondary",
                        "data-cy": "from-repository"
                      },
                      on: {
                        click: function($event) {
                          return _vm.selectItineraryFiles("others")
                        }
                      }
                    },
                    [
                      _c("feather-icon", { attrs: { icon: "ServerIcon" } }),
                      _vm._v(" Desde el repositorio ")
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._l(_vm.formData.filesOthers, function(file) {
                return _c("div", { key: file.id, staticClass: "col-3" }, [
                  _c(
                    "div",
                    { staticClass: "d-flex flex-column align-items-center" },
                    [
                      _c("vs-icon", {
                        attrs: {
                          icon: "description",
                          size: "45px",
                          color: "primary"
                        }
                      }),
                      _c(
                        "b",
                        { staticClass: "text-truncate w-100 text-center" },
                        [_vm._v(_vm._s(file.name))]
                      ),
                      _c("vs-button", {
                        attrs: { color: "danger", type: "flat", icon: "clear" },
                        on: {
                          click: function($event) {
                            return _vm.removeOthersFile(file.id)
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              }),
              _c("div", { staticClass: "col-md-12" }, [
                !!_vm.error.messageOthers
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "con-text-validation span-text-validation-danger\n            vs-input--text-validation-span v-enter-to text-left"
                      },
                      [
                        _c("span", { staticClass: "span-text-validation" }, [
                          _vm._v(" " + _vm._s(_vm.error.messageOthers) + " ")
                        ])
                      ]
                    )
                  : _vm._e()
              ])
            ],
            2
          )
        ])
      ]),
      _c(
        "div",
        { staticClass: "row justify-end" },
        [
          _c(
            "vs-button",
            {
              staticClass: "mt-5 mr-5",
              attrs: {
                "data-cy": "cancel",
                color: "primary",
                disabled: _vm.saving
              },
              on: {
                click: function($event) {
                  return _vm.back()
                }
              }
            },
            [_vm._v(" Cancelar ")]
          ),
          _c(
            "vs-button",
            {
              staticClass: "mt-5 mr-5",
              attrs: {
                "data-cy": "save",
                color: "success",
                disabled: _vm.saving
              },
              on: {
                click: function($event) {
                  return _vm.save()
                }
              }
            },
            [
              _vm._v(" Crear "),
              _c("span", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.saving,
                    expression: "saving"
                  }
                ],
                staticClass: "spinner-border spinner-border-sm text-primary"
              })
            ]
          )
        ],
        1
      ),
      _c("repository-selector", {
        attrs: {
          "modal-id": "add-file-repository",
          "add-file": _vm.addFileRepo,
          files: _vm.filesToAdd,
          "remove-file": _vm.removeFile
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("p", { staticClass: "text-justify" }, [
          _vm._v(
            " Para la compra de pasajes nacionales e internacionales se requiere completar todos los datos solicitados y adjuntar Itinerario de desplazamiento, el programa de actividades a realizar durante la comisión de servicio. La solicitud debe ser tramitada con un plazo mínimo de antelación de 20 días corridos previos a la fecha de inicio(30 días en caso de INTERNACIONAL). En caso de no cumplir con este plazo, el formulario de solicitud deberá contar con la respectiva justificación y la visación del Jefe de Servicio. "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 mt-5 mb-2" }, [
      _c("h6", [_vm._v("Datos pasajero")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 mt-5 mb-2" }, [
      _c("h6", [_vm._v("Itinerario")]),
      _c("p", [
        _vm._v(
          " La fechas y horas deben ser estimativos, ya que está dependerá de la disponibilidad. Se les recuerda que siempre se escogerá el vuelo más económico dentro del día pudiendo este ser de madrugada. EL ORIGEN SIEMPRE SERA SANTIAGO Y LOS VUELOS SON TODOS CON IDA Y VUELTA. "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 mt-5 mb-2" }, [
      _c("h6", [_vm._v("Documentos adjuntos")]),
      _c("p", [
        _vm._v(
          " Toda solicitud deberá adjuntar Itinerario de desplazamiento, el programa de actividades a realizar durante la comisión de servicio. Todo documento debe ser adjuntado en formato PDF. Para los consejeros regionales se deberá adjuntar en Otros el Acuerdo CORE. "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("label", [_vm._v("Itinerario y Programa *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("label", [_vm._v("Otros(invitación, acuerdos core, etc) *")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }